/*global _ */
import {name, mixins, props, data} from './config'
export default {
  name,
  mixins,
  props,

  data() {
    return {
      ...data,
      cartItemTemplate: {
        payload: {
          $parse: {
            product_id: {
              value: '{[selectedProduct.id]}',
            },
            count: {
              value: '{[quantity]}',
            }
          },
          options: {
            $parse: {
              products: {
                method: 'getPackageCartItemOptionsProducts'
              }
            }
          }
        },
        attributes: {
          $parse: {
            product: {
              value: '{[selectedProduct]}'
            }
          }
        }
      }
    }
  },
  computed: {
    packageProducts() {
      return _.mapKeys(_.map(this.products || [], this.getPackageProductDetails), 'id')
    },
    selectedProduct() {
      return this.packageProducts[this.fields.product]
    },
    selectedProductPrice() {
      const def = this.definitions || {}
      const optionalProductField = _.get(def, 'optionalProducts.field', 'packageOptions')
      const optionalProductId = this.fields[optionalProductField]
      return _.get(
        this.selectedProduct,
        optionalProductId ? ('prices.' + optionalProductId) : 'price',
        0
      )
    },
    proposedCartItems() {
      const product = this.selectedProduct
      if (product) {
        const item = this.buildPackageCartItem()
        return [item]
      }
      return null
    }
  },
  methods: {
    getPackageCartItemOptionsProducts() {
      const fixedProducts = this.selectedProduct.products || []
      const def = this.definitions || {}
      const bookableTypes = _.get(def, 'bookableProduct.types')
      const optionValues = _.get(def, 'bookableProduct.options', {})
      let optionFields = optionValues.fields || {}

      let bookableFound = false
      const products = fixedProducts.map(product => {
        const isBookable = bookableTypes && _.castArray(bookableTypes).includes(product.type)
        let options = {}
        if (isBookable && !bookableFound) {
          bookableFound = true
          options = _.omit(optionValues, ['fields'])
          if (!_.isEmpty(optionFields)) {
            if (_.isArray(optionFields)) {
              optionFields = _.mapKeys(optionFields)
            }
            _.forOwn(optionFields, (target, field) =>  {
              const value = _.get(this.fields, field)
              if (_.isEmpty(target) && _.isObject(value)) {
                Object.assign(options, value)
              } else {
                target = target || field
                _.set(options, target, value)
              }
            })
          }
        }
        return {
          product_id: product.id,
          options
        }
      })

      const optionalProductField = _.get(def, 'optionalProducts.field', 'packageOptions')
      const optionals = this.fields[optionalProductField]
      if (!_.isEmpty(optionals)) {
        _.forOwn(_.castArray(optionals), id => {
          products.push({product_id: _.toFinite(id), options: {}})
        })
      }
      return products
    },
    buildPackageCartItem() {
      const item = this.buildCartItem()
      item.total = this.selectedProductPrice
      const product = _.cloneDeep(this.selectedProduct)
      product.price = item.total
      item.attributes.product = product
      return item
    },
    getReactiveExtraData() {
      return {
        packageProducts: this.packageProducts,
        selectedProduct: this.selectedProduct,
      }
    },
    getPackageProductDetails(product) {
      const products = product.products.map(item => {
        const {product_id, quantity, optional} = item
        const product = _.find(this.allProducts || [], p => p.id == product_id) || {}
        const titlePath = this.$$s('package.products.titlePath', 'custom.package_product_title')
        product.title = _.get(product, titlePath, product.title)
        product.optional = optional
        product.cart = {count: quantity}
        return product
      })
      product.allProducts = products
      product.products = products.filter(p => !p.optional)
      product.optionalProducts = products.filter(p => p.optional)
      product.hasOptional = !!product.optionalProducts.length
      product.optionalTitle = product.hasOptional ? this.$$t('package.optional.title', 'Pick one') : ''
      product.original_price = product.price

      const discount = _.toFinite(product.discount_amount)
      const isPercentDiscount = product.discount_type === 'percentage'

      // debugLog({fixedProducts: product.products, discount, isPercentDiscount})
      let basePrice = _.reduce(product.products, (total, p)=> {
        return total + (_.toFinite(p.price || 0) * _.get(p, 'cart.count', 1))
      }, 0)

      basePrice = applyDiscount(basePrice, discount, isPercentDiscount)

      product.prices = _.reduce(product.optionalProducts, (all, product) => {
        all[product.id] = calculatePrice(product.price, discount, isPercentDiscount, true, basePrice)
        return all
      }, {});

      const prices = _.uniq(_.values(product.prices))
      if (prices.length === 1) {
        basePrice = prices[0]
      } else {
        basePrice = roundPrice(basePrice)
      }

      product.price = basePrice

      return product
    },
    async addToCart(goto = true)  {
      await this.$validate()
      if (this.isAnyInvalid) {
        this.scrollToFirstErrorElement()
      } else {
        const item = this.buildPackageCartItem()
        this.isBeingProcessed = true
        const success = await this.addCartItem(item)
        if (success) {
          if (goto) {
            this.goto('cart')
          } else {
            this.isBeingProcessed = false
          }
        } else {
          this.isBeingProcessed = false
        }
      }
    },
    getComponentExtraClasses() {
      return []
    },
  },
}
const calculatePrice = (amount, discount, isPercentDiscount, skipFixedDiscount, basePrice, roundIt = true) => {
  const price = _.toFinite(amount)
  const total = _.toFinite(basePrice) + applyDiscount(price, discount, isPercentDiscount, skipFixedDiscount)
  return roundPrice(total, !roundIt)
}

const applyDiscount = (amount, discount, isPercentDiscount, skipFixedDiscount) => {
  if (discount) {
    if (isPercentDiscount) {
      amount = amount * ((100-discount)/100)
    } else {
      if (!skipFixedDiscount) {
        amount = amount - discount
      }
    }
  }
  return amount
}

const roundPrice = (total, skip) => {
  if (!skip) {
    if (_.floor(total, 0) !== total) {
      total = total.toFixed(2)
    } else {
      total = _.round(total, 0)
    }
  }
  return total
}
